/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {PushMessagesRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/chat_messages.pb'
import {PushMessagesResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/chat_messages.pb'


export const genericPushMessages = (request:PushMessagesRequest, options?: CashRequestOptions) => post<PushMessagesRequest, PushMessagesResponse>("/2.0/cash/generic-push-messages", request, {...options, rejectOnError: true })